const VocabGeneralSettings = {
  /*    Account section   */
  account: ["Mi perfil", "My profile"],
  professional_register: ["Registro profesional", "Professional register"],
  /*    END account section   */

};

export default VocabGeneralSettings;
